import {useModal} from '@appscience/hooks'
import {i18n_get_TODO} from '@appscience/utils'
import {AdjustmentsIcon, DocumentDownloadIcon, DotsHorizontalIcon} from '@heroicons/react/outline'
import {Menu, Text} from '@mantine/core'
import {TableNode} from '@table-library/react-table-library'
import {TransparentActionIcon} from '../../consumables/transparent-action-icon'
import {useDataTableContext} from '../../../context'
import {DataTableActionsSectionProps} from '../model'
import {useExportPopup} from './export-csv-action'
import {VisibleColumnsPopup} from './popups/visible-columns-popup'

export function DataTableMoreButton<ColumnID extends string, ITEM extends TableNode>({
  exportCsv,
  manageColumns,
  extraActions,
}: DataTableActionsSectionProps<ColumnID, ITEM>) {
  const {allColumns} = useDataTableContext()

  const { openExportPopup } = useExportPopup(exportCsv)
  const [openManageColumnsPopup, hideManageColumnsPopup] = useModal(VisibleColumnsPopup, {
    columns: allColumns,
    selectedIds: manageColumns?.visibleColumnIds,
    onSave: ids => manageColumns?.onChange(ids as Array<ColumnID>),
    closeFn: () => hideManageColumnsPopup(),
  })

  return (
    <Menu size='md' control={<TransparentActionIcon children={<DotsHorizontalIcon className='w-5 h-5' />} />}>
      {!!manageColumns && <Menu.Item
        icon={<AdjustmentsIcon className='w-4 h-4' />}
        onClick={() => openManageColumnsPopup()}
        children={i18n_get_TODO('Manage columns')}
      />}
      {!!exportCsv && <Menu.Item
        icon={<DocumentDownloadIcon className='w-4 h-4' />}
        onClick={openExportPopup}
        rightSection={<Text size='xs' color='dimmed'>Ctrl + E</Text>}
        children={i18n_get_TODO('Export CSV')}
      />}
      {!!extraActions && extraActions.length > 0 && extraActions.map(x => <Menu.Item key={x.id} {...x} children={x.text} />)}
    </Menu>
  )
}